import styled from "styled-components";
import { Button } from "@blueprintjs/core";

import { MatchProps } from "@components/ResultFindingPanel";
import { dedent, makeResultKey } from "@utils";

const ResultFix = styled.div`
  padding: 10px;
  display: flex;
  align-items: center;
  background-color: var(--global-match-text);
  gap: 8px;
  &:hover {
    background-color: #f4da91;
  }
  &:active {
    background-color: #d8e1e8;
  }
`;

export function AutofixMatchPanel(props: MatchProps) {
  const { item, fixes, dirty, fixesApplied, onApplyFix } = props;
  return (
    <>
      {onApplyFix && fixes && fixesApplied !== undefined && (
        <>
          <ResultFix>
            <Button
              style={{
                flexShrink: 0,
                marginRight: "auto",
              }}
              small
              onClick={onApplyFix(item)}
              intent={fixesApplied[makeResultKey(item)] ? "success" : "none"}
              disabled={dirty || fixesApplied[makeResultKey(item)]}
            >
              {fixesApplied[makeResultKey(item)]
                ? "Autofix applied"
                : "Apply autofix"}
            </Button>
            <code
              className="suggested-fix bp3-code"
              style={{
                marginRight: "auto",
                whiteSpace: "nowrap",
                overflowX: "scroll",
                flexGrow: 1,
              }}
            >
              {dedent(fixes).join("\n")}
            </code>
          </ResultFix>
        </>
      )}
    </>
  );
}
